//
// Generated class SeasonEndLog
//

/// <reference path="SeasonEndLog_ManagedObject.ts" />

class SeasonEndLog extends SeasonEndLog_ManagedObject
{

}
